<!--
 * @Author: 硪要滴幸福丶 542709122@qq.com
 * @Date: 2023-02-07 11:47:54
 * @LastEditors: 硪要滴幸福丶 542709122@qq.com
 * @LastEditTime: 2024-02-01 10:39:55
 * @FilePath: \vueproject\src\components\leftnav.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
/**
* 左边菜单
*/ 
<template>
  <el-menu default-active="2" :collapse="collapsed" collapse-transition router :default-active="$route.path" unique-opened class="el-menu-vertical-demo" background-color="#334157" text-color="#fff" active-text-color="#ffd04b">
    <div class="logobox">
      <img class="logoimg" src="../assets/img/logo.png" alt="">
    </div>
    <el-submenu v-for="menu in allmenu" :key="menu.menuid" :index="menu.menuname">
      <template slot="title">
        <!-- <i class="iconfont" :class="menu.icon"></i> -->
        <i :class="menu.icon"></i>
        <span>{{menu.menuname}}</span>
      </template>
      <el-menu-item-group>
        <el-menu-item v-for="chmenu in menu.menus" :index="'/'+chmenu.url" :key="chmenu.menuid">
          <!-- <i class="iconfont" :class="chmenu.icon"></i> -->
          <i :class="chmenu.icon"></i>
          <span>{{chmenu.menuname}}</span>
        </el-menu-item>
      </el-menu-item-group>
    </el-submenu>
  </el-menu>
</template>
<script>
import { menu } from '../api/userMG'
export default {
  name: 'leftnav',
  data() {
    return {
      collapsed: false,
      allmenu: []
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    // 获取图形验证码
    let res = {
      success: true,
      data: [
        {
          menuid: 1,
          icon: 'el-icon-s-opportunity',
          menuname: '解析',
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 2,
              icon: 'el-icon-download',
              menuname: '素材解析',
              hasThird: 'N',
              url: 'scjx/Scjx',
              menus: null
            }
          ]
        },
        // {
        //   menuid: 33,
        //   icon: 'el-icon-user-solid',
        //   menuname: '用户相关',
        //   hasThird: null,
        //   url: null,
        //   menus: [
        //     {
        //       menuid: 34,
        //       icon: 'el-icon-s-custom',
        //       menuname: '用户管理',
        //       hasThird: 'N',
        //       url: 'user/WxUser',
        //       menus: null
        //     }
        //   ]
        // },
        {
          menuid: 128,
          icon: 'el-icon-bank-card',
          menuname: '卡密相关',
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 129,
              icon: 'el-icon-bank-card',
              menuname: '卡密管理',
              hasThird: 'N',
              url: 'kami/Kami',
              menus: null
            }
          ]
        },
        {
          menuid: 138,
          icon: 'el-icon-bank-card',
          menuname: '日志管理',
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 139,
              icon: 'el-icon-bank-card',
              menuname: '日志管理',
              hasThird: 'N',
              url: 'log/Log',
              menus: null
            }
          ]
        },
        {
          menuid: 148,
          icon: 'el-icon-bank-card',
          menuname: '用户管理',
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 139,
              icon: 'el-icon-bank-card',
              menuname: '用户管理',
              hasThird: 'N',
              url: 'user/WxUser',
              menus: null
            }
          ]
        },
        // {
        //   menuid: 71,
        //   icon: 'el-icon-setting',
        //   menuname: '系统管理',
        //   hasThird: null,
        //   url: null,
        //   menus: [
        //     {
        //       menuid: 72,
        //       icon: 'el-icon-user-solid',
        //       menuname: '账户管理',
        //       hasThird: 'N',
        //       url: 'system/user',
        //       menus: null
        //     }
        //   ]
        // },
      ],
      msg: 'success'
    }
          this.allmenu = res.data
    
    // menu(localStorage.getItem('logintoken'))
    //   .then(res => {
    //     console.log(JSON.stringify(res))
    //     if (res.success) {
    //       this.allmenu = res.data
    //     } else {
    //       this.$message.error(res.msg)
    //       return false
    //     }
    //   })
    //   .catch(err => {
    //     this.$message.error('菜单加载失败，请稍后再试！')
    //   })
    // 监听
    this.$root.Bus.$on('toggle', value => {
      this.collapsed = !value
    })
  }
}
</script>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 240px;
  min-height: 400px;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
  text-align: left;
}
.el-menu-item-group__title {
  padding: 0px;
}
.el-menu-bg {
  background-color: #1f2d3d !important;
}
.el-menu {
  border: none;
}
.logobox {
  height: 40px;
  line-height: 40px;
  color: #9d9d9d;
  font-size: 20px;
  text-align: center;
  padding: 20px 0px;
}
.logoimg {
  height: 40px;
}
</style>


// WEBPACK FOOTER //
// src/components/leftnav.vue